<template>
  <v-snackbar 
    :value="true" 
    timeout="-1" 
    bottom 
    :style="{ zIndex: 20000 }" 
    color="error"
    outlined
    class="snackbar_error"
  >
    <v-icon color="error">{{ mdiCloseCircleOutline }}</v-icon> like you have no internet connectivity. Please check your connection and hit REFRESH.
  </v-snackbar>
</template>

<script>
import { mdiCloseCircleOutline } from '@mdi/js';

export default {
  name: 'InternetConnectionProblem',
  data() {
    return {
      mdiCloseCircleOutline
    }
  }
};
</script>
